<template>
  <div>
    <el-card>
      <el-alert title="新闻资讯" type="info" center show-icon :closable='false'> </el-alert>

      <div class="news_container">

        <div class="news_text">
          <h3 v-if="isEdit">编辑新闻资讯</h3>
          <h3 v-else>添加新闻资讯</h3>
          <el-button size="mini" @click="goNewsList" class="btn">返回</el-button>
        </div>

        <el-form ref="newsFormRef" :model="newsForm" :rules="newsFormRules" label-width="90px" label-position="top" class="news_form">
          <el-form-item label="新闻封面:">
            <!-- 新闻封面 -->
            <el-button v-if="coverUrl != '' && coverUrl != null" type="primary" size="mini" @click="delCover">删除</el-button>
            <div class="coverImg">
              <div class="backgroundImg" v-if="coverUrl != '' && coverUrl != null">
                <img class="coverPreviewImg" :src="coverUrl" alt="">
              </div>
              <el-upload
                class="coverUpload"
                v-else
                action="string"
                list-type="picture-card"
                :http-request="uploadCover"
                accept=".png,.jpg,.jpeg"
                :show-file-list="false">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="uploadTip">建议上传比例：3:4（宽:高）</div>
          </el-form-item>

          <el-form-item label="资讯名称:" prop="title">
            <!-- 资讯题目 -->
            <el-input v-model="newsForm.title"></el-input>
          </el-form-item>

          <!-- 资讯内容富文本 -->
          <el-form-item label="资讯内容:" prop="content">
            <!-- 资讯内容 富文本组件-->
            <quill-editor-component type="news" uploadImgId="uploadImgId2" uploadVideoId="uploadVideoId2" :center-images="true" ref="quillEditorRef"></quill-editor-component>
          </el-form-item>

          <el-form-item class="btns">
            <el-button v-if="!isEdit" type="primary" @click="addNews" :loading="isAdd">添加</el-button>
            <el-button v-else type="primary" @click="addNews" :loading="isAdd">编辑</el-button>
            <el-button @click="resetNewsForm">重置</el-button>
          </el-form-item>

        </el-form>

      </div>
    </el-card>
  </div>
</template>

<script>
import { addNews, getAdminNewsById, updateNews, uploadCover, delCover } from '@/api/editNews'
import quillEditorComponent from '../../components/quillEditorComponent.vue'
export default {
  components: {
    quillEditorComponent
  },
  data () {
    return {
      // 资讯表单
      newsForm: {
        newsId: '',
        title: '',
        content: '',
        addCoverUrl: ''
      },
      // 资讯验证
      newsFormRules: {
        title: [
          { required: true, message: '请输入资讯名称', trigger: 'blur' }
        ]
      },
      // 添加按钮样式
      isAdd: false,
      // 判断编辑还是添加  默认添加
      isEdit: false,
      coverUrl: '' // 封面Url
    }
  },
  created () {
    if (this.$route.params.id != undefined) {
      // 编辑状态
      this.isEdit = true
      this.getContent(this.$route.params.id)
      this.newsForm.newsId = this.$route.params.id
    } else {
      this.isEdit = false
    }
  },
  methods: {
    // 重置
    resetNewsForm () {
      this.$refs.newsFormRef.resetFields()
      this.$refs.quillEditorRef.content = ''
      this.newsForm.content = ''
      this.newsForm.addCoverUrl = ''
    },
    // 添加保存新闻资讯  编辑保存新闻资讯
    addNews () {
      this.isAdd = true
      this.newsForm.content = this.$refs.quillEditorRef.content
      if (this.coverUrl == '' || this.coverUrl == null) {
        this.$message.error('请上传新闻封面图！')
        this.isAdd = false
        return
      } else {
        this.newsForm.addCoverUrl = this.coverUrl
      }
      this.$refs.newsFormRef.validate(valid => {
        if (!valid) return this.isAdd = false
        if (this.newsForm.content == '') {
          this.$message.error('请输入资讯内容！')
          this.isAdd = false
          return
        }

        if (!this.isEdit) {
          // 添加保存新闻资讯
          addNews(this.newsForm).then((res) => {
            if (res.code == 0) {
              this.isAdd = false
              this.$message.success('添加成功！')
              this.resetNewsForm()
              this.$router.push(this.newsListRoute())
            } else {
              this.$message.error(res.msg)
              this.isAdd = false
            }
          })
        } else {
          // 编辑保存新闻资讯
          updateNews(this.newsForm).then(res => {
            if (res.code == 0) {
              this.isAdd = false
              this.$message.success('编辑成功！')
              this.resetNewsForm()
              this.$router.push(this.newsListRoute())
            } else {
              this.$message.error(res.msg)
              this.isAdd = false
            }
          })
        }
      })
    },
    // 返回列表页面
    goNewsList () {
      this.$router.push(this.newsListRoute())
      this.resetNewsForm()
      if (this.isEdit == false && this.coverUrl != '') {
        this.delCover()
      }
    },
    newsListRoute () {
      return { name: 'admin-news', query: { ...this.$route.query } }
    },
    // 获取要修改的资讯内容
    getContent (id) {
      getAdminNewsById(id).then(res => {
        if (res.code == 0) {
          this.newsForm.title = res.data.news.title
          this.$refs.quillEditorRef.content = res.data.news.content
          this.coverUrl = res.data.news.coverUrl
        } else {
          this.$message.error('获取编辑的资讯内容失败')
        }
      })
    },
    // 上传新闻封面
    uploadCover (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadCover(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.coverUrl = res.data
        }
      })
    },
    // 删除新闻封面
    delCover () {
      if (this.isEdit == true) {
        delCover(this.newsForm.newsId, this.coverUrl).then(res => {
          if (res.code == '-1') {
            this.$message.error('删除失败！')
          } else {
            this.coverUrl = ''
          }
        })
      } else {
        delCover(null, this.coverUrl).then(res => {
          if (res.code == '-1') {
            this.$message.error('删除失败！')
          } else {
            this.coverUrl = ''
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.news_container{
  margin-top: 20px;
  .news_text{
    display: flex;
    justify-content: space-between;
    h3{
      border-bottom: 2px solid #409eff;
    }
    .btn{
      border: 0;
      color: #ccc;
      font-size: 15px;
    }
  }
}
.news_form{
  margin-top: 20px;
  .btns{
    display: flex;
    justify-content: flex-end;
  }
  .coverImg{
    display: flex;
    // overflow: auto;
    .backgroundImg{
      width: 200px;
      height: 267px;
      border-radius: 15px;
      .coverPreviewImg{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 15px;
      }
    }
  }
}

/deep/ .coverUpload .el-upload--picture-card{
  width: 200px;
  height: 267px;
  line-height: 267px;
}

.uploadTip{
  font-size: 12px;
  color: red;
}

</style>
